import { API_ENDPOINTS } from "../constants/apiEndpoints";
import axiosInstance from "../config/axiosInstance";

/**
 * Lấy danh sách lãnh đạo theo mã ngôn ngữ
 * @param {string} languageCode - Mã ngôn ngữ (vd: 'vi', 'en', 'jp')
 * @returns {Promise<Array>} - Danh sách lãnh đạo
 */
export const getLeadersByLanguage = async (languageCode) => {
    try {
        const response = await axiosInstance.get(
            API_ENDPOINTS.LEADERS.GET_BY_LANGUAGE(languageCode)
        );
        const data = response.data;

        if (data && data.success && Array.isArray(data.data)) {
            return data.data;
        }

        return [];
    } catch (error) {
        console.error(`[Leaders] Lỗi khi lấy danh sách lãnh đạo (lang=${languageCode}):`, error?.response?.status, error?.response?.data || error?.message);
        throw error;
    }
};
